import { Certificates as Constants } from "../constants";
import { certificateApi as api } from "../../api";

export const certificateAction = {
  get,
};

function get() {
  return (dispatch) => {
    return new Promise((resolve, reject) => {
      api._get().then(
        (payload) => {
          dispatch(success(payload));
          resolve(payload);
        },
        (error) => {
          dispatch(failure("Failed"));
          reject(error);
        }
      );
    });
  };
  function success(payload) {
    return { type: Constants.CERTIFICATE_SUCCESS, payload };
  }
  function failure(error) {
    return { type: Constants.CERTIFICATE_FAILED, error };
  }
}
